// @flow

const messages = {
  '204': 'No content',
  '400': 'Bad request',
  '401': 'Unauthorized',
  '403': 'Forbidden',
  '404': 'Invalid resource',
};

class ApiResponse {
  ok: boolean;
  data: ?any;
  message: ?string;
  code: ?string;

  constructor(ok: boolean, data: ?any, message: ?string, code: ?string) {
    this.ok = ok;
    this.data = data;
    this.message = message;
    const errorPrefix = 'Error: ';
    if (!!message && message.indexOf(errorPrefix) === 0) {
      this.message = message.substring(errorPrefix.length);
    }
    this.code = code;
  }

  blobLink(type: string) {
    if (!!this.data) {
      const arr: ArrayBuffer = this.data;
      const data = new Uint8Array(arr);
      const blob = new Blob([data], {type});
      return URL.createObjectURL(blob);
    }
  }

  static parse(raw: any): ApiResponse {
    const theRaw = raw || {};
    const ok = !!theRaw.data && !theRaw.data.message;
    const message = ok ? theRaw.data.message : messages[ theRaw.status ];
    const data = !!theRaw.data ? theRaw.data.data : null;
    return new ApiResponse(ok, data, message, String(theRaw.status));
  }

  static parseBinary(raw: any): ApiResponse {
    const theRaw = raw || {};
    const ok = !!theRaw.data && !theRaw.data.message;
    const message = ok ? '' : messages[ theRaw.status ];
    return new ApiResponse(ok, theRaw.data, message, String(theRaw.status));
  }

  static parseError(raw: any): ApiResponse {
    if (!raw || !raw.response) {
      return new ApiResponse(false, null, String(raw));
    }
    let message = messages[ raw.response.status ];
    if (raw.response.data && raw.response.data.message) {
      message = raw.response.data.message;
    }
    return new ApiResponse(false, null, message, String(raw.response.status));
  }

  is401Error() {
    return !this.ok && this.code === '401';
  }
}

export default ApiResponse;
